import { useEffect, useRef, useState } from 'react';

interface CountdownProps {
  expiresAt: string;
  onExpire?: () => void;
}

function format(ms: number): string {
  const total = Math.max(0, Math.floor(ms / 1000));
  const h = Math.floor(total / 3600);
  const m = Math.floor((total % 3600) / 60);
  const s = total % 60;
  const pad = (n: number) => n.toString().padStart(2, '0');
  return h > 0 ? `${pad(h)}:${pad(m)}:${pad(s)}` : `${pad(m)}:${pad(s)}`;
}

export default function Countdown({ expiresAt, onExpire }: CountdownProps) {
  const expiresMs = new Date(expiresAt).getTime();
  const [remaining, setRemaining] = useState(() => expiresMs - Date.now());
  const firedRef = useRef(false);

  useEffect(() => {
    firedRef.current = false;
    const tick = () => setRemaining(expiresMs - Date.now());
    tick();
    const id = window.setInterval(tick, 1000);
    return () => window.clearInterval(id);
  }, [expiresMs]);

  useEffect(() => {
    if (remaining <= 0 && !firedRef.current) {
      firedRef.current = true;
      onExpire?.();
    }
  }, [remaining, onExpire]);

  const warn = remaining > 0 && remaining < 60_000;
  return (
    <span className={warn ? 'countdown warn' : 'countdown'}>
      {format(remaining)}
    </span>
  );
}
